'use strict';
jQuery($ => {

class DeviceCluster {
	constructor(devices) {
		this.devices = devices;

		$(devices).find('.device-cluster__device').each((i, ui) => {
			this.setupDevice(ui);
		});
	}

	setupDevice(device) {
		const deviceKey = device.getAttribute('data-device-key');
		const z = window.getComputedStyle(device).getPropertyValue("z-index");
		const svg = device.querySelector('svg');
		const screen = svg.querySelector('.device-screen');
		const bounds = screen.getBoundingClientRect();

		const childPos = $(screen).offset();
		const parentPos = $(svg).offset();
		const childOffset = {
			top: Math.floor(childPos.top - parentPos.top),
			left: Math.floor(childPos.left - parentPos.left),
		};

		// Create the initial screen element to fill with video
		let deviceScreen = document.createElement('div');
		deviceScreen.classList.add('device-screen-overlay');
		deviceScreen.style.zIndex = Number(z) + 1;
		deviceScreen.style.top = childOffset.top + 'px';
		deviceScreen.style.left = childOffset.left + 'px';
		deviceScreen.style.width = (Math.floor(bounds.width) + 1) + 'px';
		deviceScreen.style.height = (Math.ceil(bounds.height) + 1) + 'px';
		deviceScreen.style.overflow = "hidden";

		// Create a video element, start playing
		let deviceVideo = document.createElement('video');
		deviceVideo.src = "/wp-content/themes/gecko-theme/videos/"+deviceKey+".mp4";
		deviceVideo.loop = true;
		deviceVideo.muted = true;
		deviceVideo.autoplay = true;

		// Use these settings to stretch the video to fill screen
		deviceVideo.style.width = '100%';
		deviceVideo.style.height = '100%';
		deviceVideo.style.objectFit = "fill";

		// Add the video to the device screen
		deviceScreen.append(deviceVideo);
		// Add the device screen to the device
		device.append(deviceScreen);

		setTimeout(() => {
			deviceVideo.play();
		}, 100);


		// Toggle play/pause
		deviceVideo.addEventListener('click', (e) => {
			e.preventDefault();
			if (deviceVideo.paused) {
				deviceVideo.play();
				// reflectionVideo.play();
			} else {
				deviceVideo.pause();
				// reflectionVideo.pause();
			}
		});
	}

	reflow() {
		$(this.devices).find('.device-cluster__device').each((i, ui) => {
			const svg = ui.querySelector('svg');
			const screen = svg.querySelector('.device-screen');
			const bounds = screen.getBoundingClientRect();

			const childPos = $(screen).offset();
			const parentPos = $(svg).offset();
			const childOffset = {
				top: Math.floor(childPos.top - parentPos.top),
				left: Math.floor(childPos.left - parentPos.left),
			};

			const overlay = ui.querySelector('.device-screen-overlay');
			overlay.style.top = childOffset.top + 'px';
			overlay.style.left = childOffset.left + 'px';
			overlay.style.width = (Math.floor(bounds.width) + 1) + 'px';
			overlay.style.height = (Math.ceil(bounds.height) + 1) + 'px';
		});
	}
}

$(document).ready(() => {
	// Find the 'Devices' section on document ready
	const devices = document.getElementById('device-cluster__container');

	if (devices) {
		// Set up the canvas if element exists
		const deviceCluster = new DeviceCluster(devices);

		$(window).on('resize', () => {
			console.log('resized window');
			deviceCluster.reflow();
		});
	}
});

});